import { render, staticRenderFns } from "./rule-override-form.vue?vue&type=template&id=73d82fcd&scoped=true&lang=pug&"
import script from "./rule-override-form.vue?vue&type=script&lang=ts&"
export * from "./rule-override-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d82fcd",
  null
  
)

export default component.exports